<template>
    <div class="group">
        <div class="hd">
            <div class="left">
                代码位合集
                <span class="tips">先审后投仅对绑定了代码位合集的代码位生效</span>
            </div>
            <div class="right">
                <el-button v-if="!isSubUser" type="text" size="medium" @click="handleAdd">+代码位合集</el-button>
            </div>
        </div>
        <div class="bd" ref="groupWrap" @mouseenter="handleGroupMouseEnter" @mouseleave="handleGroupMouseLeave">
            <div v-if="groupListLoaded && !groupList.length && !isSubUser" class="no_record" @click="handleAdd">
                设置代码位合集
            </div>
            <ul v-else class="bd_list" :style="{ 'width': (groupList.length ? (groupList.length * groupItemWidth) : 1600) + 'px', 'transform': `translateX(${moveX}px)` }">
                <li v-for="(item, i) in groupList" :key="i" :class="{'on': item.id === collectionId}" @click="handleSelect(item)" :title="item.collection_name">
                    <div class="id">合集ID: {{ item.id }}</div>
                    <div class="title">合集名称: {{ item.collection_name }}</div>
                    <div class="ctrl_num">素材数: {{ item.idea_count }}</div>
                    <div class="ctrl_btns" v-if="!isSubUser">
                        <a href="javascript:;" class="ctrl_btn" @click="handleModify(item)">修改</a>
                        <a href="javascript:;" class="ctrl_btn" @click="handleDelete(item)" v-if="!item.adslot.length">删除</a>
                    </div>
                </li>
            </ul>
            <a href="javascript:;" class="btn_ctrl_prev" v-if="ctrlBtnVisible" @click="handleGroupPrev"><span class="arr"></span></a>
            <a href="javascript:;" class="btn_ctrl_next" v-if="ctrlBtnVisible" @click="handleGroupNext"><span class="arr"></span></a>
        </div>
    
        <!-- 新增 & 编辑 -->
        <el-dialog :title="(form.id ? '编辑代码位合集' : '新增代码位合集')" width="800px" :visible.sync="dialogFormVisible">
            <el-form label-width="100px" :model="form">
                <el-form-item label="合集名称">
                    <el-input v-model="form.name" size="small" style="width: 94%;"></el-input>
                </el-form-item>
                <el-form-item label="选择代码位">
                    <el-input placeholder="请输入搜索内容" size="small" style="width: 94%;" clearable v-model="formSearchKey" @keyup.enter.native="handleSearch">
                        <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
                    </el-input>
                </el-form-item>
                <el-form-item>
                    <div class="transfer">
                        <div class="transfer_item">
                            <div class="t_hd">
                                <div class="hd_cont">
                                    <el-checkbox v-model="formAdSlotCheckAll" @change="handleSelectAll">全选</el-checkbox>
                                </div>
                            </div>
                            <div class="t_bd">
                                <el-checkbox-group class="bd_list" v-model="form.adslot">
                                    <template v-for="item in adSlotList">
                                        <div class="row" :key="item.id" v-if="!item.isHide" :title="item.name">
                                            <el-checkbox :label="item">{{item.id}} {{item.name}}</el-checkbox>
                                        </div>
                                    </template>
                                </el-checkbox-group>
                            </div>
                        </div>
                        <div class="transfer_item">
                            <div class="t_hd"></div>
                            <div class="t_bd">
                                <div class="bd_list">
                                    <div class="row" v-for="(item, i) in form.adslot" :key="item.id" :title="item.name">
                                        <i class="el-icon-remove" @click="handleSelectDel(i)"></i>
                                        {{item.adslot_id || item.id}} {{item.name}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="dialogFormVisible = false">取消</el-button>
                <el-button size="small" type="primary" @click="handleGroupConfirm">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {
    getPreviewCollectionAdslotList,
    getPreviewCollectionInfo,
    getPreviewCollectionList,
    setPreviewCollectionAdd,
    setPreviewCollectionEdit,
    setPreviewCollectionDelete
} from '@/apis/advCenter.js';

export default {
    name: 'audit-group',
    data() {
        return {
            wrapWidth: 0,
            previewNum: 0,
            moveX: 0,
            moveIndex: 0,
            groupListLoaded: false,
            groupList: [],
            groupItemWidth: 215,
            ctrlBtnVisible: false,
            currentId: 0,
    
            dialogFormVisible: false,
            value: '',
            adSlotList: [],
            formAdSlotCheckAll: false,
            formSearchKey: '',
            form: {
                id: '',
                name: '',
                adslot: []
            },
            collectionId: '',
            isSubUser: false // 子账号
        }
    },
    
    props: {
        page: String,
        search: Object,
        listReload: Boolean
    },
    
    watch: {
        listReload(oldVal, newVal) {
            console.log('group watch listReload >>> ', oldVal, newVal);
            this.getAdSlotList();
        },
        search(oldVal, newVal) {
            console.log('group watch search >>> ', oldVal, newVal);
            this.getAdSlotList();
        }
    },
    
    methods: {
        init() {
            const userInfo = this.$ls.get('userInfo');
            this.isSubUser = userInfo.main_user || false;
            
            this.wrapWidth = this.$refs.groupWrap.offsetWidth;
            this.previewNum = Math.floor(this.wrapWidth / this.groupItemWidth);
            window.addEventListener('resize', () => {
                this.wrapWidth = this.$refs.groupWrap.offsetWidth;
                this.previewNum = Math.floor(this.wrapWidth / this.groupItemWidth);
                this.moveX = 0;
                this.moveIndex = 0;
            });
            
            this.getAdSlotList();
        },
        
        async getAdSlotList() {
            let params = {
                page: 1,
                page_size: 9999
            };
            
            if (this.page === 'stay') params['review_type'] = 0;
            if (this.page === 'pass') params['review_type'] = 1;
            if (this.page === 'reject') params['review_type'] = 2;
            if (this.search.date && this.search.date.length) params['audit_time'] = this.search.date[0] + '~' + this.search.date[1];
            if (this.search.keyword) params['idea_title'] = this.search.keyword;
            if (this.search.adSlotId) params['adslot_id'] = this.search.adSlotId;
            if (this.search.materialType) params['acc_adtype'] = this.search.materialType;
            if (this.search.os || this.search.os === 0) params['os'] = this.search.os;
            
            const res = await getPreviewCollectionList(params);
            this.groupListLoaded = true;
            if (res && res.code === 200) {
                this.groupList = res.data.list;
                !this.collectionId && this.handleSelect(this.groupList[0]); // 默认点击第一个
            }
            this.$emit('update:listReload', false);
        },
        
        handleGroupPrev() {
            if (!this.moveIndex) return;
            this.moveIndex--;
            this.moveX = (this.moveIndex * this.groupItemWidth) * -1;
        },
        
        handleGroupNext() {
            if (this.moveIndex + this.previewNum < this.groupList.length) {
                this.moveIndex++;
                this.moveX = (this.moveIndex * this.groupItemWidth) * -1;
            }
        },
        
        handleGroupMouseEnter() {
            if (!this.groupList.length || this.groupList.length <= this.previewNum) return;
            this.ctrlBtnVisible = true;
        },
        handleGroupMouseLeave() {
            this.ctrlBtnVisible = false;
        },
        
        // 选择代码位合集
        handleSelect(item) {
            if (item && item.id) {
                this.collectionId = item.id;
                this.$emit('callback', {collectionId: this.collectionId});
            }
        },
        
        // 删除代码位合集
        handleDelete(item) {
            this.$confirm('确定删除此合集吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                const res = await setPreviewCollectionDelete({
                    id: item.id,
                    version: item.version
                });
                if (res && res.code === 200) {
                    this.$message.success('删除成功');
                    this.getAdSlotList();
                }
            });
        },
        
        // 新增代码位合集
        handleAdd() {
            this.dialogFormVisible = true;
            this.formAdSlotCheckAll = false;
            this.formSearchKey = '';
            this.form.id = '';
            this.form.version = '';
            this.form.name = '';
            this.form.adslot = [];
            this.getCollectionAdslotList();
        },
    
        // 修改代码位合集
        async handleModify(item) {
            await this.getCollectionAdslotList();
            const {code, data, message} = await getPreviewCollectionInfo({ id: item.id });
            if (code && code === 200) {
                this.form.id = data.list.id;
                this.form.version = data.list.version;
                this.form.name = data.list.collection_name;
                this.form.adslot = data.list.adslot;
                this.dialogFormVisible = true;
            } else {
                this.dialogFormVisible = false;
                this.$message.error(message);
            }
        },
        handleSearch() {
            this.adSlotList.forEach(v => {
                v.isHide = !(v.name.indexOf(this.formSearchKey) >= 0 || (v.id.toString()).indexOf(this.formSearchKey) >= 0);
            });
            this.$forceUpdate();
        },
        handleSelectAll(status) {
            let arr = [];
            this.adSlotList.forEach(v => {
                if (!v.isHide) {
                    arr.push(v);
                }
            });
            this.form.adslot = status ? arr : [];
        },
        handleSelectDel(i) {
            this.form.adslot.splice(i, 1);
        },
        async getCollectionAdslotList() {
            const res = await getPreviewCollectionAdslotList({
                page: 1,
                page_size: 9999
            });
            if (res && res.code === 200) {
                this.adSlotList = res.data.list;
            }
        },
    
        // 确认
        async handleGroupConfirm() {
            let adSlotId = [];
            this.form.adslot.forEach(v => {
                adSlotId.push(v.adslot_id || v.id);
            });
            
            if (!this.form.name) {
                this.$message.error('请输入合集名称');
                return;
            }
            
            // if (!adSlotId.length) {
            //     this.$message.error('请选择代码位');
            //     return;
            // }
            
            let params = {
                collection_name: this.form.name,
                adslot_id: adSlotId
            }
            let res = '';
            if (this.form.id) {
                params['id'] = this.form.id;
                params['version'] = this.form.version;
                res = await setPreviewCollectionEdit(params);
            } else {
                res = await setPreviewCollectionAdd(params);
            }
            
            if (res && res.code === 200) {
                this.getAdSlotList();
                this.formAdSlotCheckAll = false;
                this.formSearchKey = '';
                this.form = {
                    id: '',
                    name: '',
                    adslot: []
                }
                this.dialogFormVisible = false;
                this.$emit('callbackReload', { reload: true });
            } else {
                this.$message.error('');
            }
        }
    },
    
    mounted() {
        this.init();
    }
}
</script>

<style lang="scss" scoped>
.group{
    margin-top: 10px;
    & .hd{
        display: flex;
        justify-content: space-between;
        align-items: center;
        & .left{
            font-size: 14px;
            font-weight: bold;
            & .tips{
                font-size: 12px;
                font-weight: normal;
                color: #409EFF;
            }
        }
        & .right{}
    }
    & .bd{
        position: relative;
        margin-top: 10px;
        height: 92px;
        overflow: hidden;
        & .no_record{
            width: 200px;
            height: 92px;
            line-height: 92px;
            text-align: center;
            font-size: 14px;
            color: #fff;
            background: linear-gradient(to bottom,  rgba(66,195,255,1) 0%,rgba(64,126,249,1) 100%);
            border-radius: 5px;
            cursor: pointer;
        }
        & .bd_list{
            margin: 0;
            padding: 0;
            width: 1600px;
            list-style: none;
            overflow: hidden;
            transition-duration: .5s;
            & li{
                position: relative;
                float: left;
                margin-right: 15px;
                width: 200px;
                min-height: 92px;
                border-radius: 5px;
                overflow: hidden;
                background: linear-gradient(to bottom,  rgba(238,238,238,1) 0%,rgba(206,206,206,1) 100%);
                cursor: pointer;
                &.on{
                    background: linear-gradient(to bottom,  rgba(66,195,255,1) 0%,rgba(64,126,249,1) 100%);
                    & .id{color: #fff;}
                    & .title{color: #fff;}
                    & .ctrl_num{color: #fff;}
                    & .ctrl_btns{
                        & .ctrl_btn{color: #fff;}
                    }
                }
                & .id{
                    margin: 10px auto auto;
                    width: 180px;
                    height: 20px;
                    line-height: 20px;
                    font-size: 14px;
                    color: #666;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                }
                & .title{
                    margin: auto;
                    width: 180px;
                    height: 30px;
                    line-height: 30px;
                    font-size: 14px;
                    color: #666;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                }
                & .ctrl_num{
                    margin: auto 10px auto;
                    width: 180px;
                    height: 20px;
                    line-height: 20px;
                    font-size: 14px;
                    color: #666;
                }
                & .ctrl_btns{
                    position: absolute;
                    right: 5px;
                    bottom: 5px;
                    height: 26px;
                    text-align: right;
                    display: flex;
                    justify-content: flex-end;
                    & .ctrl_btn{
                        margin-left: 5px;
                        text-decoration: none;
                        color: #409EFF;
                        font-size: 14px;
                        display: flex;
                        justify-content: flex-end;
                        padding-bottom: 15px;
                        &:hover{text-decoration: underline;}
                    }
                }
            }
        }
        & .btn_ctrl_prev, & .btn_ctrl_next{
            position: absolute;
            top: 0;
            width: 30px;
            height: 100%;
            background: rgba(0, 0, 0, 0.2);
            display: flex;
            align-items: center;
            & .arr{
                display: block;
                width: 20px;
                height: 20px;
                &::after{
                    display: block;
                    content: '';
                    height: 15px;
                    width: 15px;
                    border-width: 2px 2px 0 0;
                    border-color: #fff;
                    border-style: solid;
                    transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
                    position: absolute;
                }
            }
        }
        & .btn_ctrl_prev{
            justify-content: flex-end;
            left: 0px;
            & .arr{transform: rotate(-180deg);}
        }
        & .btn_ctrl_next{
            justify-content: flex-start;
            right: 0px;
        }
    }
}

.transfer{
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    & .transfer_item{
        margin-right: 15px;
        width: 300px;
        border: 1px solid #DCDFE6;
        border-radius: 4px;
        & .t_hd{
            height: 40px;
            background: #f9f9f9;
            border-bottom: 1px solid #DCDFE6;
            border-top-left-radius: 4px;
            border-top-right-radius: 4px;
            & .hd_cont{
                margin: auto;
                width: 90%;
            }
        }
        & .t_bd{
            margin-top: 6px;
            margin-bottom: 6px;
            height: 200px;
            overflow-y: scroll;
            overflow-x: hidden;
            & .bd_list{
                margin: auto;
                width: 90%;
                & .row{
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
            }
        }
    }
}
</style>
